import { render, staticRenderFns } from "./StudentLectionMenu.vue?vue&type=template&id=30fd7b9c&"
import script from "./StudentLectionMenu.vue?vue&type=script&lang=js&"
export * from "./StudentLectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./StudentLectionMenu.vue?vue&type=style&index=0&id=30fd7b9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports